import script from "./Step3MetodoPago.vue?vue&type=script&setup=true&lang=js"
export * from "./Step3MetodoPago.vue?vue&type=script&setup=true&lang=js"

import "./Step3MetodoPago.vue?vue&type=style&index=0&id=52490c9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52490c9e"]])

export default __exports__